export default __webpack_public_path__ + "static/media/search-normal.cdf04ee7.svg";